module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/prod-06-3e8b4dc60c873521d3b7be3d0cb49f78.jpg";